import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RenderUnsettledUI, SmallLoader } from 'shared/components';
import { IconAdd } from 'assets/img';
import { LwButton } from 'redesign';
import { useWorkersPoolFlexWorkersHandlers } from './hooks/use-workers-pool-flex-workers-handlers';
import { WorkersPoolFlexWorkersTable } from './workers-pool-flex-workers-table';
import { FlexWorkersSearchBar } from '../../../flex-pool-detail/components/flex-workers/components/flex-workers-search-bar';

type WorkersPoolFlexWorkersProps = {
  workersPoolId: string;
};

export const WorkersPoolFlexWorkers = ({ workersPoolId }: WorkersPoolFlexWorkersProps) => {
  const { t } = useTranslation('ogp-screen-specific');
  const {
    nameInputValue,
    setNameInputValue,
    data,
    error,
    refetch,
    status,
    PopupProfileElement,
    handleShowFlexWorker,
    handleRemoveFlexWorker,
    handleAddFlexWorker,
  } = useWorkersPoolFlexWorkersHandlers(workersPoolId);

  if (status !== 'success') {
    return <RenderUnsettledUI renderLoading={<SmallLoader />} data={{ error, refetch, status }} />;
  }

  const flexWorkers = data ?? [];

  return (
    <>
      {PopupProfileElement}
      <Grid container alignItems="center" justifyItems="center" columnSpacing={4}>
        <Grid item xs={9}>
          <FlexWorkersSearchBar
            value={nameInputValue}
            setValue={setNameInputValue}
            id="search_workers_pool_flexworkers"
          />
        </Grid>
        <Grid item xs={3}>
          <LwButton
            iconColorMode="fill"
            color="primary"
            startIcon={<IconAdd />}
            onClick={handleAddFlexWorker}
          >
            {t('flexpools.external.workers.add_worker_button')}
          </LwButton>
        </Grid>
      </Grid>
      {flexWorkers.length === 0 ? (
        <p>{t('flexpools.external.workers.empty_state')}</p>
      ) : (
        <WorkersPoolFlexWorkersTable
          data={flexWorkers}
          onRemoveFlexWorker={handleRemoveFlexWorker}
          onShowFlexWorker={handleShowFlexWorker}
        />
      )}
    </>
  );
};
